/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { CircularProgress } from "@mui/material";
import { deleteAccount } from "api";
import { verifyDeleteAccount } from "api";
import { notify } from "utilities";

function Basic() {
  const location = useLocation();
  const { mobile, code, type } = location.state || {};
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [otp, setOtp] = useState("");

  const [timer, setTimer] = useState(60);

  useEffect(() => {
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval); // Clean up on unmount
  }, [timer]);

  const handleResendOtp = () => {
    // Trigger OTP resend logic here
    setTimer(60); // Restart the timer
    deleteAccountApi();
  };

  const handleContinue = () => {
    if (mobile) {
      setIsSubmitted(false);
      verifyDeleteAccountApi();
    } else {
      setIsSubmitted(true);
    }
  };

  const deleteAccountApi = () => {
    var params = {
      phone: mobile,
      code: code,
      type: type,
    };

    setIsLoading(true);
    deleteAccount({
      params: params,
    })
      .then((responseJson) => {
        setIsLoading(false);

        if (responseJson) {
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const verifyDeleteAccountApi = () => {
    var params = {
      phone: mobile,
      code: code,
      type: type,
      otp: otp,
    };

    setIsLoading(true);
    verifyDeleteAccount({
      params: params,
    })
      .then((responseJson) => {
        setIsLoading(false);

        if (responseJson) {
          notify();
          navigate(-1);
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          //   borderRadius="xl"
          coloredShadow="info"
          // mx={2}
          // mt={-3}
          p={3}
          mb={1}
          textAlign="center"
          sx={{
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Enter OTP
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="white" mt={1}>
            OTP sent to {code} {mobile}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleContinue(); // same as your onClick
            }}
          >
            <MDBox mb={2}>
              <MDInput
                type="otp"
                label="OTP"
                fullWidth
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                helperText={isSubmitted && !otp ? "OTP is required" : ""}
                FormHelperTextProps={{
                  sx: {
                    color: "red",
                    marginLeft: "0",
                  },
                }}
              />
            </MDBox>

            <MDBox mt={2} mb={1} textAlign="left">
              {timer > 0 ? (
                <MDTypography variant="button" color="text">
                  {`00:${String(timer).padStart(2, "0")} seconds`}
                </MDTypography>
              ) : (
                <MDTypography
                  component={Link}
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  onClick={handleResendOtp}
                  sx={{ mt: 1 }}
                >
                  Resend OTP
                </MDTypography>
              )}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                // component={Link}
                // to="/authentication/sign-up"
                // onClick={handleContinue}
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} color="light" /> : "Submit"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
